<template>
  <div class="tree">
    <a-tree
      v-if="dataSourse.length"
      :tree-data="dataSourse"
      blockNode
      defaultExpandAll
      :replace-fields="replaceFields"
      @select="onSelect"
      v-model:selectedKeys="selectedKeys"
    >
      <template #title="{ phraseName, phraseNum, id, phraseLevel, isHover, mode }">
        <!-- 新增/编辑模式下 -->
        <div
          v-if="mode !== 'edit' && mode !== 'add'"
          class="treeChild"
          @mouseenter="hoverEnter(id, phraseLevel, 'hover')"
          @mouseleave="hoverEnter(id, phraseLevel, 'leave')"
        >
          <span class="name">{{ phraseName }}</span>
          <span v-if="!isHover" class="num">
            {{ phraseNum }}
          </span>
          <div v-else class="action">
            <PlusSquareOutlined v-if="phraseLevel === 1" @click.stop="add(id)" />
            <EditOutlined v-if="phraseLevel === 2" @click.stop="edit(id)" />
            <DeleteOutlined v-if="phraseLevel === 2 && phraseNum === 0" @click.stop="del(id)" />
          </div>
        </div>
        <a-input
          :maxlength="10"
          :defaultValue="phraseName"
          class="editInput"
          size="small"
          v-else
          placeholder="请输入"
          @pressEnter="e => onPressEnter(e, id)"
          @blur="e => onBlur(e, id)"
          @click="
            e => {
              e.stopPropagation()
            }
          "
        />
      </template>
    </a-tree>
  </div>
</template>
<script>
import { defineComponent, ref, createVNode } from 'vue'
import {
  PlusSquareOutlined,
  EditOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined
} from '@ant-design/icons-vue'
import { findNode } from '@/utils/index'
import { message, Modal } from 'ant-design-vue'
import { getLeftTree, addOrUpdate } from '@/api/Speach/index.js'

export default defineComponent({
  name: 'Tree',
  props: {
    mode: String // edit 为编辑模式可支持修改分类
  },
  components: {
    PlusSquareOutlined,
    EditOutlined,
    DeleteOutlined
  },
  setup(props, { emit }) {
    const selectedKeys = ref([])
    //主树数据结构
    const dataSourse = ref([])
    //替换 treeNode 中 title,key,children 字段为 treeData 中对应的字段
    const replaceFields = {
      children: 'listNode',
      title: 'phraseName',
      key: 'id'
    }
    //新增分类默认数据
    const defaultListNode = {
      phraseName: '',
      phraseLevel: 2,
      phraseNum: 0,
      mode: 'add'
    }
    //新增分类
    const add = id => {
      //初始化状态
      initTree(dataSourse.value)
      const data = findChild(id)
      const { listNode = [] } = data
      //判断子集下面是否有新增未保存的分类
      const addData = findNode(listNode, 'listNode', node => {
        return node.mode === 'add'
      })
      if (addData) return message.warning('当前存在未保存的话术分类')
      listNode.push({ ...defaultListNode, id: new Date().getTime(), patientId: data.id })
    }
    //编辑
    const edit = id => {
      //初始化状态
      initTree(dataSourse.value)
      const data = findChild(id)
      data.mode = 'edit'
    }
    //删除
    const del = id => {
      Modal.confirm({
        title: '删除确认',
        icon: createVNode(ExclamationCircleOutlined),
        content: '确定删除该分类及分类下所有话术内容吗？',
        okText: '确定',
        cancelText: '取消',
        centered: true,
        onOk: () => {
          const data = findChild(id)
          update(data, true)
        }
      })
    }
    //鼠标移入移出事件
    const hoverEnter = (id, phraseLevel, type) => {
      if (props.mode !== 'edit') return
      if (phraseLevel === 0) return
      const data = findChild(id)
      data.isHover = type === 'hover'
    }
    //回车提交
    const onPressEnter = (e, id) => {
      const val = e.target._value && e.target._value.replace(/\s+/g, '')
      if (!val) return message.warning('话术分类名称不能为空')
      const data = findChild(id)
      data.phraseName = val
      update(data)
    }
    //失去焦点
    const onBlur = (e, id) => {
      const data = findChild(id)
      if (!data) return
      if (data.mode === 'edit' || data.mode === 'add') {
        const val = e.target._value && e.target._value.replace(/\s+/g, '')
        if (!val)
          return data.mode === 'edit'
            ? message.warning('话术分类名称不能为空')
            : initTree(dataSourse.value)
        data.phraseName = val
        update(data)
      }
    }
    //选择节点
    const onSelect = e => {
      emit('handleChange', e[0])
    }
    //查询子节点
    const findChild = id => {
      const data = findNode(dataSourse.value, 'listNode', node => {
        return node.id === id
      })
      return data
    }
    //初始化树机构状态
    const initTree = treeList => {
      if (!treeList || !treeList.length) {
        return
      }
      for (let i = 0; i < treeList.length; i++) {
        treeList[i].mode = ''
        if (!treeList[i].phraseName) {
          treeList.splice(i, 1)
          break
        }
        initTree(treeList[i].listNode)
      }
    }
    //获取话术分类数据
    const leftTree = () => {
      getLeftTree().then((res = []) => {
        const allPhraseNum = res.reduce((sum, current) => sum + current.phraseNum, 0)
        dataSourse.value = [
          {
            phraseName: '全部',
            id: -1,
            phraseLevel: 0,
            phraseNum: allPhraseNum,
            listNode: [...res]
          }
        ]
      })
    }
    //更新分类
    const update = ({ patientId, phraseLevel, phraseName, id, mode }, delFlag = false) => {
      let params = { patientId, phraseLevel, phraseName }
      if (mode === 'edit' || delFlag) {
        params = {
          ...params,
          id
        }
      }
      //删除标记
      if (delFlag) {
        params = {
          ...params,
          delFlag: 1
        }
      }
      //更新分类
      addOrUpdate(params).then(() => {
        const msg = delFlag ? '删除成功' : '保存成功'
        message.success(msg)
        leftTree()
      })
    }
    leftTree()
    // 初始化选中的值
    const initselectedKeys = () => {
      selectedKeys.value = []
    }
    return {
      update,
      leftTree,
      initTree,
      findChild,
      onSelect,
      onBlur,
      onPressEnter,
      add,
      edit,
      del,
      hoverEnter,
      replaceFields,
      dataSourse,
      selectedKeys,
      initselectedKeys
    }
  }
})
</script>
<style lang="scss" scoped>
.tree {
  padding: 0 24px;
  height: 100%;
  overflow: scroll;
  ::v-deep(.ant-tree-title .treeChild) {
    white-space: pre-wrap;
    align-items: flex-start;
  }
  ::v-deep(.ant-tree li .ant-tree-node-content-wrapper) {
    padding: 0;
    padding: 1px 0;
    line-height: initial;
    height: auto;
  }
  ::v-deep(.ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected) {
    background: #f0faff;
    .treeChild .name {
      color: #1890ff;
    }
  }
  .treeChild {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 5px;
    .name {
      font-size: 14px;
      color: #595959;
    }
    .num {
      font-size: 14px;
      color: #bfbfbf;
    }
    .anticon {
      color: #8c8c8c;
      font-size: 16px;
      cursor: pointer;
    }
    .anticon:last-child {
      margin-left: 12px;
    }
  }
  .editInput {
    width: 100%;
  }
}
</style>
